import { render, staticRenderFns } from "./ChatBot.vue?vue&type=template&id=c53cd84c"
import script from "./ChatBot.vue?vue&type=script&lang=ts"
export * from "./ChatBot.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports